
import getSwiperSlider from '~/js/modules/slider';

window.addEventListener('DOMContentLoaded', () => {

  const newsSwiperParams = {
    slidesPerView: `auto`,
    loop: false,
    autoplay: false,
    navigation: {
      nextEl: `.news .slider-arrows__arrow--next`,
      prevEl: `.news .slider-arrows__arrow--prev`,
      disabledClass: `disabled`,
    },
    pagination: false,
  };

  const newsSlider = document.querySelector('.js-slider');
  if (newsSlider) {
    getSwiperSlider(newsSlider, newsSwiperParams);
  }

});
